import { CouponFrequency } from "@goodfill/domain-properties";
import React from "react";

export const PaymentFrequencyComponent = (props: { value: CouponFrequency }) => (
  <>{props.value.equals(2) ? "Semi Annual" : props.value.equals(4) ? "Quarterly" : `${props.value} / year`}</>
);
